import { useOutletContext } from 'react-router-dom';
import { VendorsInner } from './Vendors';
import type { User } from '../api/types';

/**
 * Suppliers tab — wraps VendorsInner in embedded mode so the parent
 * PurchasingLayout owns the Header + the page chrome. All vendor scorecard
 * + line-card content stays identical to the legacy /vendors page.
 */
export default function PurchasingSuppliers() {
  const user = useOutletContext<User>();
  return <VendorsInner user={user} embedded />;
}
